import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { LoginModule } from '../components/login/login.module';
import { OtpModule } from '../components/otp/otp.module';
import { UpdateMobileModule } from '../components/update-mobile/update-mobile.module';
import { AuthDialogComponent } from './auth-dialog.component';
import { DeleteAccountModule } from '../components/delete-account/delete-account.module';

@NgModule({
	declarations: [AuthDialogComponent],
	imports: [SharedModule, LoginModule, OtpModule, UpdateMobileModule, DeleteAccountModule],
	exports: [AuthDialogComponent],
})
export class AuthDialogModule {}
